import { useAuth } from './useAuth';
import { translations } from '../i18n';
import type { Language, Translations } from '../i18n';

function getGameLanguage(user: any): Language {
  const person = user?.person;
  if (!person) return 'en';

  // person.data may be a parsed object or a JSON string
  let data = person.data;
  if (typeof data === 'string') {
    try { data = JSON.parse(data); } catch { return 'en'; }
  }

  const lang = data?.gameLanguage;
  if (lang === 'nl' || lang === 'fr' || lang === 'de') return lang;
  return 'en';
}

/**
 * Returns the current language and full translation object.
 * Reads person.data.gameLanguage from the authenticated user.
 * Falls back to 'en' if not set or invalid.
 */
export function useTranslation(): { lang: Language; t: Translations } {
  const { user } = useAuth();
  const lang = getGameLanguage(user);
  return { lang, t: translations[lang] };
}
